import { render } from "./choosePeople.vue?vue&type=template&id=a09c4164"
import script from "./choosePeople.vue?vue&type=script&lang=js"
export * from "./choosePeople.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__